// @ts-check
import * as React from "react"

import {QueryProvider} from "./frameworks/react-query"

/**
 * @param {{children: React.ReactNode}} param0
 */
export default function RootProvider({children}) {
  return <QueryProvider>{children}</QueryProvider>
}
